module.exports.Formly = require('./src/components/Formly');
module.exports.FieldMixin = require('./src/mixins/FieldMixin');
module.exports.FormlyConfig = require('./src/modules/FormlyConfig');




/*****************
 ** WEBPACK FOOTER
 ** ./index.js
 ** module id = 0
 ** module chunks = 0
 **/